const scrollTrigger = document.querySelectorAll('.js-scroll-trigger');

scrollTrigger.forEach((elem) => {
	ScrollTrigger.create({
	  trigger: elem,
	  start: "top bottom",
	  end: "bottom top",
	  toggleClass: { targets: elem, className: "active" },
	  markers: false
	});
  });

  
let smoother = null;

gsap.matchMedia().add('(min-width: 750px)', function () {
  smoother = ScrollSmoother.create({
    smooth: 1.5,
    effects: true
  });
  return function () {
    if (smoother) {
      smoother.kill();
      smoother = null;
    }
  };
});

// Watch the element that actually grows. On desktop #smooth-wrapper is
// position:fixed, so documentElement stays viewport-height and never reflects
// content/image loads — observe #smooth-content (with documentElement as a
// mobile fallback) so lazy images and late layout shifts trigger a refresh.
const smoothContent = document.getElementById('smooth-content');

// A ScrollTrigger.refresh() while ScrollSmoother is active re-anchors the
// scroll position and re-applies every effect/pin transform instantly — a
// visible "jump". Lazy images decoding as you scroll grow #smooth-content and
// would fire a refresh on every change. So only refresh when the height
// actually GROWS past a meaningful threshold (a real late layout shift),
// ignore shrinks/sub-pixel noise, and never refresh while one is in flight.
const REFRESH_GROWTH_THRESHOLD = 24; // px — below this is noise, not a real shift
let lastContentHeight = smoothContent ? smoothContent.offsetHeight : 0;
let resizeTimer;
const debouncedRefresh = function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    if (ScrollTrigger.isRefreshing) return;
    const h = smoothContent ? smoothContent.offsetHeight : document.documentElement.offsetHeight;
    // Compare against the height at the LAST refresh so slow, sub-threshold
    // drift still accumulates to a refresh once it adds up to something real.
    if (h - lastContentHeight < REFRESH_GROWTH_THRESHOLD) return;
    lastContentHeight = h;
    ScrollTrigger.refresh();
  }, 250);
};

const resizeObserver = new ResizeObserver(debouncedRefresh);
if (smoothContent) {
  resizeObserver.observe(smoothContent);
} else {
  resizeObserver.observe(document.documentElement);
}

// Deferred scripts measure pin positions before images/fonts finish loading,
// which lands pins in the wrong spot until something forces a recompute.
// Refresh once everything that affects layout has settled.
function refreshAndSyncBaseline() {
  ScrollTrigger.refresh();
  lastContentHeight = smoothContent ? smoothContent.offsetHeight : document.documentElement.offsetHeight;
}
window.addEventListener('load', refreshAndSyncBaseline);
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(refreshAndSyncBaseline);
}

// Pin collection list header while the list scrolls (works with ScrollSmoother)
const collectionListPin = document.getElementById('collection-list-pin-trigger');
const collectionListHeading = document.getElementById('collection-list-heading');
if (collectionListPin) {
	const list = document.querySelector('.section--collection-list .collection-list');
	ScrollTrigger.create({
		trigger: collectionListPin,
		start: 'top 160px',
		endTrigger: list || collectionListPin.closest('.section--collection-list'),
		end: 'bottom bottom',
		pin: true,
		pinSpacing: false
	});
}

// Mobile: the pinned intro sits in the path of the scrolling product images —
// fade it out when the first image reaches it, back in when scrolling returns.
if (collectionListPin) {
	gsap.matchMedia().add('(max-width: 749px)', function () {
		const intro = document.querySelector('.section--collection-list .collection__intro');
		const firstItem = document.querySelector('.section--collection-list .product-item');
		if (!intro || !firstItem) return;
		ScrollTrigger.create({
			trigger: firstItem,
			// Wait until the first item's top has scrolled halfway up the screen
			// before fading the pinned intro.
			start: 'top 50%',
			onEnter: function () { gsap.to(intro, { opacity: 0, duration: 0.3, overwrite: 'auto' }); },
			onLeaveBack: function () { gsap.to(intro, { opacity: 1, duration: 0.3, overwrite: 'auto' }); }
		});
		// The fade tweens run after setup, so matchMedia doesn't auto-revert
		// their inline style — clear it when leaving mobile.
		return function () { gsap.set(intro, { clearProps: 'opacity' }); };
	});
}

// Rich-text metafields / collection.description hold HTML entities (&amp;) even
// after strip_html, and Liquid's `escape` in the data attribute escapes them
// AGAIN. The parser only undoes one level, so getAttribute still returns
// "&amp;" — which textContent then displays literally. Decode that remaining
// level here. (Liquid has no entity-decode filter, so JS is the right place.)
function decodeEntities(str) {
	if (!str || str.indexOf('&') === -1) return str;
	const el = document.createElement('textarea');
	el.innerHTML = str;
	return el.value;
}

// Update pinned heading and intro synced with collection__ctas: first product on scroll down, last product on scroll up
const collectionListIntro = document.getElementById('collection-list-intro');
if (collectionListHeading || collectionListIntro) {
	const productTriggerY = 160;
	document.querySelectorAll('.section--collection-list .collection.js-collection').forEach(function (collectionEl) {
		const heading = decodeEntities(collectionEl.getAttribute('data-collection-heading'));
		const intro = decodeEntities(collectionEl.getAttribute('data-collection-intro'));
		if (!heading && !intro) return;
		const products = collectionEl.querySelectorAll('.product-item.js-product-viewport');
		if (!products.length) return;
		const firstProduct = products[0];
		const lastProduct = products[products.length - 1];

		function updateHeadingAndIntro() {
			if (collectionListHeading && heading) collectionListHeading.textContent = heading;
			if (collectionListIntro && intro !== null) collectionListIntro.textContent = intro || '';
		}

		// Scroll down: heading/intro update when first product hits 75% (same moment as first product CTA)
		ScrollTrigger.create({
			trigger: firstProduct,
			start: 'top 75%',
			end: 'bottom ' + productTriggerY + 'px',
			onEnter: updateHeadingAndIntro
		});
		// Scroll up: heading/intro update when last product's bottom hits 160px (same moment as that product's CTA)
		ScrollTrigger.create({
			trigger: lastProduct,
			start: 'top 75%',
			end: 'bottom ' + productTriggerY + 'px',
			onEnterBack: updateHeadingAndIntro
		});
	});
}

// Update pinned product (release, title, wrapper link, View Item link) when a product enters the viewport
const collectionListProductLink = document.getElementById('collection-list-product-link');
const collectionListProductRelease = document.getElementById('collection-list-product-release');
const collectionListProductTitle = document.getElementById('collection-list-product-title');
const collectionListViewItemLink = document.getElementById('collection-list-view-item-link');
if (collectionListProductLink || collectionListProductRelease || collectionListProductTitle || collectionListViewItemLink) {
	const productTriggerY = 160;
	document.querySelectorAll('.section--collection-list .product-item.js-product-viewport').forEach(function (productEl) {
		const url = productEl.getAttribute('data-product-url');
		const title = decodeEntities(productEl.getAttribute('data-product-title'));
		const release = decodeEntities(productEl.getAttribute('data-product-release'));
		ScrollTrigger.create({
			trigger: productEl,
			start: 'top 75%',
			end: 'bottom ' + productTriggerY + 'px',
			onEnter: function () {
				if (collectionListProductLink && url) collectionListProductLink.href = url;
				if (collectionListProductRelease && release !== null) collectionListProductRelease.textContent = release || '';
				if (collectionListProductTitle && title !== null) collectionListProductTitle.textContent = title || '';
				if (collectionListViewItemLink && url) collectionListViewItemLink.href = url;
			},
			onEnterBack: function () {
				if (collectionListProductLink && url) collectionListProductLink.href = url;
				if (collectionListProductRelease && release !== null) collectionListProductRelease.textContent = release || '';
				if (collectionListProductTitle && title !== null) collectionListProductTitle.textContent = title || '';
				if (collectionListViewItemLink && url) collectionListViewItemLink.href = url;
			}
		});
	});
}

// Pin each product's gallery band to top as media scrolls (same height as pinned header)
document.querySelectorAll('.section--collection-list .product-item').forEach(function (productItem) {
	const gallery = productItem.querySelector('.block__gallery');
	if (!gallery) return;
	ScrollTrigger.create({
		trigger: productItem,
		start: 'top 40px',
		end: 'bottom bottom',
		pin: gallery,
		pinSpacing: false
	});
});

// Pin product details content on desktop (replaces CSS sticky broken by ScrollSmoother)
const productDetailsContent = document.querySelector('.product__details-content');
const productDetailsInner = document.querySelector('.product__details-inner');
let productDetailsPin = null;
function createProductDetailsPin() {
	if (productDetailsPin) {
		productDetailsPin.kill();
		productDetailsPin = null;
	}
	if (productDetailsContent && productDetailsInner && window.innerWidth >= 750) {
		productDetailsPin = ScrollTrigger.create({
			trigger: productDetailsContent,
			start: 'top 40px',
			endTrigger: productDetailsInner,
			end: 'bottom bottom',
			pin: true,
			pinSpacing: false
		});
	}
}
if (productDetailsContent && productDetailsInner) {
	createProductDetailsPin();
	window.addEventListener('resize', createProductDetailsPin);
}

// Detect if a link's href goes to the current page
function getSamePageAnchor (link) {
	if (
		link.protocol !== window.location.protocol ||
		link.host !== window.location.host ||
		link.pathname !== window.location.pathname ||
		link.search !== window.location.search
	) {
		return false;
	}

	return link.hash;
}

// Scroll to a given hash, preventing the event given if there is one
function scrollToHash(hash, e) {
	const elem = hash ? document.querySelector(hash) : false;
	if ( elem ) {
		if ( e ) e.preventDefault();
		//gsap.to( window, { scrollTo: elem } );
		if (smoother) smoother.scrollTo(elem, true);
	}
}

// If a link's href is within the current page, scroll to it instead
document.querySelectorAll( 'a[href]' ).forEach( a => {
	a.addEventListener( 'click', e => {
		scrollToHash( getSamePageAnchor( a ), e );
		document.activeElement.blur();
	});
});

// Scroll to the element in the URL's hash on load
scrollToHash(window.location.hash);


let fadeIns = document.querySelectorAll('.js-fade-in');

fadeIns.forEach(elem => {

	let fadeInAnim = gsap.timeline({paused: true})
	.fromTo(elem, 1, { opacity: 0 }, { opacity: 1, ease: "sine.out"})

	ScrollTrigger.create({
		trigger: elem,
		start: "top 90%",
		once: true,
		onEnter: ({progress, direction, isActive}) => fadeInAnim.play(),
		markers: false
	});

});